exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: block;\r\n}\r\n\r\n:host-context(body.body--fullscreen-layout) {\r\n  display: block;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.edit-spec-general-page {\r\n  padding: 24px;\r\n}\r\n\r\n:host-context(body.body--fullscreen-layout) .edit-spec-general-page {\r\n  box-sizing: border-box;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.edit-spec-general-page__title {\r\n  margin: 0 0 20px;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--color-text, #212529);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/edit-specialization-general-page/edit-specialization-general-page.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/edit-specialization-general-page/edit-specialization-general-page.component.css
// module chunks = main